// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group_list_more_results{display:flex;align-items:center;justify-content:center;height:43px;background:#fff;cursor:pointer;color:#4467ab;border-bottom:1px solid #e2e8f0}", ""]);
// Exports
module.exports = exports;
